module.exports = __webpack_public_path__ + "img/Section.25828c0b.png";